"use client";
import * as Accordion from "@radix-ui/react-accordion";
import { motion } from "framer-motion";
import { HiChevronDown } from "react-icons/hi";
import { FadeUp } from "@/components/ui/section";
import { useState } from "react";
import { useTranslations } from "next-intl";

export default function FAQ() {
  const [value, setValue] = useState(null);
  const t = useTranslations("home");
  const faqs = t.raw("faqs");

  return (
    <section className="py-24 lg:py-32 bg-zinc-950">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <FadeUp className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-white">{t("faqsHeading")}</h2>
        </FadeUp>

        <Accordion.Root
          type="single"
          collapsible
          value={value}
          onValueChange={setValue}
          className="space-y-3"
        >
          {faqs.map((faq, i) => (
            <Accordion.Item key={i} value={`item-${i}`}>
              <div className="rounded-2xl bg-white border border-zinc-200 shadow-sm hover:border-violet-400/50 dark:bg-zinc-900 dark:border-white/[0.08] dark:shadow-none dark:hover:border-violet-500/20 transition-colors overflow-hidden">
                <Accordion.Trigger className="w-full flex items-center justify-between px-6 py-5 text-left">
                  <span className="text-sm font-medium text-zinc-900 dark:text-white">{faq.q}</span>
                  <motion.span
                    animate={{ rotate: value === `item-${i}` ? 180 : 0 }}
                    transition={{ duration: 0.2 }}
                    className="flex-shrink-0 ml-4"
                  >
                    <HiChevronDown className="w-4 h-4 text-zinc-400 dark:text-zinc-500" />
                  </motion.span>
                </Accordion.Trigger>
                <Accordion.Content className="px-6 pb-5 text-sm text-zinc-600 dark:text-zinc-400 leading-relaxed">
                  {faq.a}
                </Accordion.Content>
              </div>
            </Accordion.Item>
          ))}
        </Accordion.Root>
      </div>
    </section>
  );
}
